import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {

	return ( {
		dialogRoot: {
			padding         : "0",
			backgroundColor : `${ theme.other.colors.background.primary } !important`,
			width           : "100%",
			height          : "80vh",
			borderRadius    : "15px"
		},
		modalContent: {
			flex     : "0 0 auto",
			// width    : "100%",
			width    : "100%",
			maxWidth : "600px"

		},
		dialogContainer: {
			maxWidth : "600px",
			width    : "100%"
		},
		appBar: {
			background   : theme.other.colors.background.tertiary,
			color        : "black",
			borderBottom : theme.other.darkMode ? "none" : "1px solid #e7e7e7",
			boxShadow    : "none",
			zIndex       : "5 !important",
			position     : "sticky",
			top          : 0
		},
		appBarContainer: {
			display: "flex"
		},
		listContainer: {
			overflow: "scroll"
		},
		tabsFlexContainer: {
			justifyContent: "space-around"
		},
		tabIndicator: {
			// maxWidth: 50,
			borderTopRightRadius : "25px",
			borderTopLeftRadius  : "25px",
			height               : "3px",
			left                 : "0 !important",
			width                : "50% !important"
		},
		tabIndicatorLikes: {
			borderTopRightRadius : "25px",
			borderTopLeftRadius  : "25px",
			height               : "3px",
			right                : "0 !important",
			width                : "50% !important",
			left                 : "auto !important"
		},
		tabRoot: {
			flex: "1"
		},
		emptyStateContainer: {
			height         : "100%",
			display        : "flex",
			flexDirection  : "column",
			justifyContent : "center",
			alignItems     : "center"
		},
		crossIconContainer: {
			textAlign : "end",
			padding   : "1rem 1rem 0 0"

		},
		crossIconDark: {
			filter    : "invert(1)",
			transform : "scale(0.7)",
			cursor    : "pointer"
		},
		crossIcon: {
			cursor : "pointer",
			height : "3rem",
			width  : "3rem"
		},
		unActiveText: {
			textTransform : "none",
			fontSize      : "1.5rem",
			fontWeight    : "500"

		},
		activeText: {
			textTransform : "none",
			fontWeight    : "500",
			fontSize      : "1.5rem",
			color         : `${ theme.other.paletteNew.primaryDarkBlue } !important`
		},
		separator: {
			borderTop : `1px solid ${ theme.other.colors.border.primary }`,
			width     : "90%",
			position  : "relative",
			left      : "12.5%"
		},
		contentContainer: {
			margin: "10px 20px"
		},
		searchIcon: {
			marginRight: "1rem"
		},
		root: {
			background   : "#f3f3f3",
			borderRadius : "10px",
			marginTop    : "6px !important",
			borderColor  : "#e7e7e7"
		},
		notchedOutline: {
			borderWidth : "1px",
			borderColor : "#e7e7e700 !important"
		},
		cssFocused: {
			borderColor: "#126bd5 !important"
		},

		cardsListContainer: {
			backgroundColor : theme.other.colors.background.primary,
			flex            : "1"
			// minHeight       : "100%"
		}

	} );
} );
